export default ["M16 7.99l-16-6 4 6-4 6z"];
//# sourceMappingURL=direction-right.js.map